/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Tags_ColorInputs */

const cs_clients_tags_color = /** @type {(inputs: Clients_Tags_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barva`)
};

const en_clients_tags_color = /** @type {(inputs: Clients_Tags_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Color`)
};

/**
* | output |
* | --- |
* | "Color" |
*
* @param {Clients_Tags_ColorInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_tags_color = /** @type {((inputs?: Clients_Tags_ColorInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Tags_ColorInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_tags_color(inputs)
	return cs_clients_tags_color(inputs)
});